export default __webpack_public_path__ + "static/logo_grey-1e678f32b75686754125031401ea014d.svg";